/* eslint-disable */

import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createFilterOptions } from "@mui/material";
import { useForm, useFormState } from "react-final-form";
import { fetchAllAsync, fetchAllByClienteAsync, selectTabelaFrete } from "../../features/tabela-frete/tabelaFreteSlice";
import QCXAutocompleteSelect from "../autocomplete-select/QCXAutocompleteSelect";

export default function QCXSelectTabelaFreteAutocomplete({ label, name, initialValues, defaultCode, ...restProps }) {
  const dispatch = useDispatch();
  const list = useSelector(selectTabelaFrete);

  const form = useForm();
  const { values, initialValues: formInitialValues } = useFormState();
  const localInitialValues = useMemo(() => initialValues || formInitialValues, [initialValues, formInitialValues]);

  const clienteId = values?.cliente?.id;

  useEffect(() => {
    if (!clienteId) {
      form.change(name, null);
      dispatch(resetList()); 
      return;
    }

    dispatch(fetchAllByClienteAsync(clienteId));

    form.change(name, null);
  }, [clienteId]);

  const [defaultValue, setDefaultValue] = useState('');

  useEffect(() => {
    const defaultMoeda = list?.find((m) => m.id === defaultCode);
    if (defaultMoeda && defaultValue !== defaultMoeda) {
      setDefaultValue(defaultMoeda);
      return;
    }

    const value = list.find((item) => item.id === Number(_.get(localInitialValues, name)));

    if (value && defaultValue !== value) {
      setDefaultValue(value);
    } else if (!value && defaultValue.id !== null) {
      setDefaultValue({ id: null, description: '' });
    }
  }, [list, localInitialValues, name, defaultCode, defaultValue]);

  const filterOptions = createFilterOptions({
    stringify: (option) => (option?.moeda ? `${option?.moeda?.sigla} - ${option.id}` : ''),
  });
  return (
    <QCXAutocompleteSelect
      label={label}
      id={name}
      name={name}
      options={list}
      filterOptions={filterOptions}
      defaultValue={defaultValue}
      getOptionLabel={(item) => (item?.moeda ? `${item?.moeda?.description} - ${item.id}` : '')}
      {...restProps}
    />
  );

}